document.addEventListener('DOMContentLoaded', function () {
  const step1 = document.getElementById('withdrawal-step-1');
  const step2 = document.getElementById('withdrawal-step-2');
  const step3 = document.getElementById('withdrawal-step-3');
  const form = document.getElementById('withdrawal-request-form');
  const confirmBtn = document.getElementById('withdrawal-confirm-btn');
  const backBtn = document.getElementById('withdrawal-back-btn');

  let pendingData = null;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    pendingData = {
      name: document.getElementById('withdrawal-name').value.trim(),
      email: document.getElementById('withdrawal-email').value.trim(),
      order_number: document.getElementById('withdrawal-order').value.trim(),
      submitted_at: new Date().toISOString()
    };

    document.getElementById('confirm-name').textContent = pendingData.name;
    document.getElementById('confirm-email').textContent = pendingData.email;
    document.getElementById('confirm-order-number').textContent = pendingData.order_number;

    step1.style.display = 'none';
    step2.style.display = 'block';
  });

  backBtn.addEventListener('click', function () {
    step2.style.display = 'none';
    step1.style.display = 'block';
  });

  confirmBtn.addEventListener('click', function () {
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Submitting...';

    const webhookUrl = window.withdrawalWebhookUrl;

    fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': '782d552o6l2c0l22486f1q054f377o216q1r27765b4b7t3e473q76151n55064n'
      },
      body: JSON.stringify(pendingData)
    })
      .then(function () {
        step2.style.display = 'none';
        step3.style.display = 'block';
      })
      .catch(function () {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Confirm withdrawal';
        alert('Something went wrong submitting your request. Please try again or contact support.');
      });
  });
});